export const APP_ADAPTER_DEFAULTS = {
    CDDLOPTIONS: '{"CreateTable":{"action":"IgnoreIfExists","options":[{"CreateSchema":{"action":"IgnoreIfExists"}}]}}',
    MODE: "MERGE"
};
